export const videosPartB = [
  {
    id: "a1",
    title: "星海骑士团",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20young%20knight%20in%20shining%20armor%20standing%20on%20a%20cliff%20facing%20a%20vast%20starry%20sky%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a1&orientation=landscape",
    duration: "全 24 集",
    uploadedAt: "2024-09-20",
    year: "2024",
    region: "日本",
    type: "热血",
    playCount: 1560000,
    rating: 9.2,
    uploader: "樱都动画",
    description: "被星海选召的少年踏上守护银河的旅途，与同伴并肩对抗吞噬光芒的暗影军团。",
    tags: ["热血", "冒险", "科幻"],
  },
  {
    id: "a2",
    title: "云端小镇",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20village%20floating%20among%20soft%20clouds%20at%20sunrise%20with%20glowing%20lanterns%20and%20green%20hills%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a2&orientation=landscape",
    duration: "全 12 集",
    uploadedAt: "2024-08-14",
    year: "2024",
    region: "中国大陆",
    type: "治愈",
    playCount: 880000,
    rating: 8.9,
    uploader: "云上工作室",
    description: "漂浮在云端的小镇上，少女与邻居们相互守护，度过一个温柔而奇妙的夏天。",
    tags: ["治愈", "日常", "奇幻"],
  },
  {
    id: "a3",
    title: "机械纪元",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20giant%20robot%20towering%20over%20a%20ruined%20futuristic%20city%20with%20glowing%20blue%20energy%20lines%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a3&orientation=landscape",
    duration: "全 26 集",
    uploadedAt: "2023-12-18",
    year: "2023",
    region: "日本",
    type: "科幻",
    playCount: 1620000,
    rating: 9.0,
    uploader: "钢铁之魂",
    description: "在人类与机械共存的未来末世，一名少年驾驶员揭开埋藏在废都之下的惊天秘密。",
    tags: ["科幻", "机甲", "战斗"],
  },
  {
    id: "a4",
    title: "龙语者",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20dragon%20coiling%20around%20an%20ancient%20temple%20with%20floating%20rune%20symbols%20and%20ember%20particles%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a4&orientation=landscape",
    duration: "全 20 集",
    uploadedAt: "2024-07-07",
    year: "2024",
    region: "中国大陆",
    type: "奇幻",
    playCount: 1340000,
    rating: 8.8,
    uploader: "龙渊动漫",
    description: "能够听懂龙语的少女踏上寻找失落龙族的旅程，在古老咒语中揭开血脉的真相。",
    tags: ["奇幻", "冒险", "成长"],
  },
  {
    id: "a5",
    title: "校园迷糊事",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20sunny%20school%20classroom%20with%20cherry%20blossoms%20drifting%20through%20open%20windows%20and%20desks%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a5&orientation=landscape",
    duration: "全 12 集",
    uploadedAt: "2024-06-28",
    year: "2024",
    region: "日本",
    type: "日常",
    playCount: 960000,
    rating: 8.6,
    uploader: "青春社",
    description: "一群性格天差地别的同学，在平凡又热闹的校园生活里制造出一连串爆笑名场面。",
    tags: ["日常", "搞笑", "青春"],
  },
  {
    id: "a6",
    title: "熊猫大冒险",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20animated%20panda%20walking%20through%20a%20lush%20bamboo%20forest%20with%20warm%20sunlight%20and%20butterflies%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a6&orientation=landscape",
    duration: "全 52 集",
    uploadedAt: "2023-10-16",
    year: "2023",
    region: "中国大陆",
    type: "合家欢",
    playCount: 1120000,
    rating: 8.5,
    uploader: "竹林动画",
    description: "一只贪吃又勇敢的小熊猫为寻找传说中的竹林秘境，踏上了欢乐连连的冒险旅途。",
    tags: ["合家欢", "冒险", "萌宠"],
  },
  {
    id: "a7",
    title: "暗影侦探社",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20dim%20detective%20office%20at%20night%20with%20a%20glowing%20desk%20lamp%20and%20a%20magnifying%20glass%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a7&orientation=landscape",
    duration: "全 13 集",
    uploadedAt: "2023-09-25",
    year: "2023",
    region: "日本",
    type: "推理",
    playCount: 790000,
    rating: 8.7,
    uploader: "谜题社",
    description: "三位少年侦探组成暗影侦探社，在城市夜幕下破解一个个看似无解的离奇案件。",
    tags: ["推理", "悬疑", "校园"],
  },
  {
    id: "a8",
    title: "四季物语",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20peaceful%20Japanese%20countryside%20house%20across%20four%20seasons%20with%20soft%20glowing%20light%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-a8&orientation=landscape",
    duration: "全 12 集",
    uploadedAt: "2022-12-20",
    year: "2022",
    region: "中国大陆",
    type: "治愈",
    playCount: 620000,
    rating: 8.4,
    uploader: "田埂工作室",
    description: "乡间小屋里，祖孙二人用一整年记录四季更替，在最平常的日子里感受生活的温度。",
    tags: ["治愈", "日常", "温情"],
  },
  {
    id: "d1",
    title: "蓝色星球",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Sweeping%20underwater%20reef%20scene%20with%20sunbeams%20piercing%20blue%20water%20and%20a%20humpback%20whale%20gliding%20past%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d1&orientation=landscape",
    duration: "全 8 集",
    uploadedAt: "2024-09-05",
    year: "2024",
    region: "英国",
    type: "自然",
    playCount: 1420000,
    rating: 9.4,
    uploader: "自然影像",
    description: "深入全球最神秘的海域，用超高清镜头记录海洋生物鲜为人知的生存智慧与奇观。",
    tags: ["自然", "海洋", "科普"],
  },
  {
    id: "d2",
    title: "失落的文明",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20overgrown%20stone%20temple%20ruins%20in%20a%20jungle%20with%20golden%20sunlight%20and%20vines%20everywhere%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d2&orientation=landscape",
    duration: "全 6 集",
    uploadedAt: "2023-11-14",
    year: "2023",
    region: "法国",
    type: "历史",
    playCount: 980000,
    rating: 9.0,
    uploader: "时光考据",
    description: "考古队深入丛林，重现那些曾经辉煌却神秘消失的古文明，解读失落的过往。",
    tags: ["历史", "考古", "人文"],
  },
  {
    id: "d3",
    title: "舌尖之旅",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20Chinese%20village%20kitchen%20with%20steaming%20street%20food%20and%20warm%20morning%20light%20streaming%20in%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d3&orientation=landscape",
    duration: "全 10 集",
    uploadedAt: "2024-08-02",
    year: "2024",
    region: "中国大陆",
    type: "美食",
    playCount: 1680000,
    rating: 9.2,
    uploader: "五味纪录",
    description: "跟随镜头走遍山川湖海，探寻各地风味背后的匠心与传承，品味中国人的饮食哲学。",
    tags: ["美食", "人文", "旅行"],
  },
  {
    id: "d4",
    title: "宇宙深处",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20space%20telescope%20view%20of%20a%20spiral%20galaxy%20with%20vivid%20nebula%20clouds%20and%20scattered%20stars%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d4&orientation=landscape",
    duration: "全 6 集",
    uploadedAt: "2023-12-28",
    year: "2023",
    region: "美国",
    type: "科学",
    playCount: 1120000,
    rating: 9.1,
    uploader: "星辰科普",
    description: "从星系诞生到黑洞演化，带你穿越亿万光年，探寻宇宙最深处的奥秘与浪漫。",
    tags: ["科学", "宇宙", "科普"],
  },
  {
    id: "d5",
    title: "山与海之间",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Lone%20hiker%20on%20a%20misty%20mountain%20ridge%20overlooking%20a%20vast%20sea%20of%20clouds%20at%20dawn%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d5&orientation=landscape",
    duration: "全 5 集",
    uploadedAt: "2024-06-19",
    year: "2024",
    region: "中国大陆",
    type: "人文",
    playCount: 740000,
    rating: 8.8,
    uploader: "远山影像",
    description: "记录生活在山海之间的普通人，用镜头讲述他们与土地、与自然的朴素连结。",
    tags: ["人文", "自然", "纪实"],
  },
  {
    id: "d6",
    title: "匠心",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20artisan%20hands%20shaping%20clay%20in%20a%20dim%20workshop%20with%20warm%20glowing%20lantern%20light%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d6&orientation=landscape",
    duration: "全 8 集",
    uploadedAt: "2023-09-30",
    year: "2023",
    region: "中国大陆",
    type: "手艺",
    playCount: 680000,
    rating: 9.0,
    uploader: "守艺纪录",
    description: "走进非遗传承人的工坊，看一双双粗糙的手如何把时光与热爱打磨成传世之物。",
    tags: ["手艺", "人文", "传承"],
  },
  {
    id: "d7",
    title: "城市脉动",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20a%20bustling%20city%20with%20glowing%20highways%20and%20endless%20light%20trails%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d7&orientation=landscape",
    duration: "全 6 集",
    uploadedAt: "2022-10-11",
    year: "2022",
    region: "日本",
    type: "社会",
    playCount: 590000,
    rating: 8.6,
    uploader: "都市观察",
    description: "以航拍与街头纪实相结合，捕捉超级都市昼夜不息的心跳与普通人的生活轨迹。",
    tags: ["社会", "城市", "纪实"],
  },
  {
    id: "d8",
    title: "极地之行",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=Frozen%20polar%20landscape%20at%20blue%20hour%20with%20glowing%20ice%20cliffs%20and%20a%20tiny%20distant%20expedition%20tent%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-d8&orientation=landscape",
    duration: "全 4 集",
    uploadedAt: "2023-10-21",
    year: "2023",
    region: "英国",
    type: "探险",
    playCount: 860000,
    rating: 9.1,
    uploader: "远征纪实",
    description: "跟随探险队深入极地冰原，记录人类在极端环境下的勇气、孤独与生命奇迹。",
    tags: ["探险", "自然", "纪实"],
  },
  {
    id: "s1",
    title: "一分钟料理",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20vibrant%20fresh%20salad%20being%20tossed%20on%20a%20bright%20kitchen%20counter%20with%20sunlight%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s1&orientation=landscape",
    duration: "01:08",
    uploadedAt: "2024-09-22",
    year: "2024",
    region: "中国大陆",
    type: "美食",
    playCount: 860000,
    rating: 8.7,
    uploader: "快手厨房",
    description: "用一分钟教你做出一道快手家常菜，步骤清晰、食材简单，新手也能轻松上手。",
    tags: ["美食", "教程", "生活"],
  },
  {
    id: "s2",
    title: "萌宠日常",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20golden%20retriever%20puppy%20jumping%20in%20a%20sunny%20living%20room%20with%20flying%20soft%20toys%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s2&orientation=landscape",
    duration: "00:52",
    uploadedAt: "2024-08-28",
    year: "2024",
    region: "中国大陆",
    type: "宠物",
    playCount: 1240000,
    rating: 9.0,
    uploader: "毛孩子频道",
    description: "记录一只金毛幼犬的成长日常，搞怪、撒娇、拆家，每一帧都治愈到不行。",
    tags: ["宠物", "萌宠", "治愈"],
  },
  {
    id: "s3",
    title: "街头魔术",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20magician%20performing%20a%20glowing%20card%20trick%20at%20night%20with%20a%20small%20amazed%20crowd%20around%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s3&orientation=landscape",
    duration: "01:35",
    uploadedAt: "2024-07-30",
    year: "2024",
    region: "美国",
    type: "魔术",
    playCount: 980000,
    rating: 8.9,
    uploader: "惊奇街头",
    description: "魔术师在闹市街头随机邀请路人参与表演，近景魔术令人目瞪口呆、直呼不可思议。",
    tags: ["魔术", "街头", "创意"],
  },
  {
    id: "s4",
    title: "旅行碎片",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Traveler%20silhouette%20watching%20a%20glowing%20sunset%20over%20a%20calm%20coastal%20road%20with%20palm%20trees%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s4&orientation=landscape",
    duration: "02:04",
    uploadedAt: "2023-11-26",
    year: "2023",
    region: "日本",
    type: "旅行",
    playCount: 720000,
    rating: 8.6,
    uploader: "在路上",
    description: "把旅途中最美的瞬间剪成一段治愈短片，海浪、晚霞与公路，带你一起远行。",
    tags: ["旅行", "风景", "治愈"],
  },
  {
    id: "s5",
    title: "冷知识实验室",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20science%20lab%20desk%20with%20glowing%20colorful%20liquids%20in%20glassware%20and%20soft%20blue%20light%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s5&orientation=landscape",
    duration: "01:20",
    uploadedAt: "2024-06-15",
    year: "2024",
    region: "中国大陆",
    type: "科普",
    playCount: 1050000,
    rating: 8.8,
    uploader: "好奇君",
    description: "用趣味实验拆解生活中的冷知识，原来那些习以为常的现象背后藏着这么多学问。",
    tags: ["科普", "实验", "趣味"],
  },
  {
    id: "s6",
    title: "手绘日记",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20hand%20sketching%20a%20colorful%20illustration%20in%20a%20warm%20notebook%20with%20glowing%20paint%20splashes%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s6&orientation=landscape",
    duration: "01:12",
    uploadedAt: "2023-12-08",
    year: "2023",
    region: "韩国",
    type: "动画",
    playCount: 610000,
    rating: 8.5,
    uploader: "纸笔时光",
    description: "插画师用一段延时短片记录手绘全过程，笔尖流动之间，一幅温暖画作慢慢成形。",
    tags: ["动画", "手绘", "创意"],
  },
  {
    id: "s7",
    title: "极限瞬间",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Surfer%20carving%20through%20a%20giant%20glowing%20wave%20at%20sunset%20with%20spray%20flying%20in%20golden%20light%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s7&orientation=landscape",
    duration: "01:48",
    uploadedAt: "2024-05-30",
    year: "2024",
    region: "澳大利亚",
    type: "运动",
    playCount: 930000,
    rating: 8.9,
    uploader: "极限视界",
    description: "冲浪、滑板与攀岩高手集结，用慢镜头捕捉肾上腺素飙升的极限瞬间。",
    tags: ["运动", "极限", "热血"],
  },
  {
    id: "s8",
    title: "深夜电台",
    categoryId: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20radio%20studio%20with%20a%20warm%20glowing%20on%20air%20sign%20and%20a%20vintage%20microphone%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-s8&orientation=landscape",
    duration: "02:30",
    uploadedAt: "2023-08-19",
    year: "2023",
    region: "中国大陆",
    type: "情感",
    playCount: 540000,
    rating: 8.4,
    uploader: "夜航电台",
    description: "深夜电台用温柔的声音讲述听众来信，陪你度过每一个辗转难眠的夜晚。",
    tags: ["情感", "治愈", "生活"],
  },
];